<div class="field-dialog dialog-reopen-maintenance">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'MAINTENANCES.REALLOCATE_MAINTENANCE' | translate }} - {{ maintenance.number }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <form
    name="form"
    [formGroup]="reopenMaintenancesForm"
    fusePerfectScrollbar
    class="dialog-reopen-maintenance__content"
  >
    <div class="dialog-reopen-maintenance__content__card maintenance-section">
      <label class="dialog-reopen-maintenance__content__card__title">
        {{ 'MAINTENANCES.REALLOCATE_DIALOG.MAINTENANCE' | translate }}
      </label>

      <mat-form-field appearance="legacy">
        <mat-label>{{ 'MAINTENANCES.NUMBER' | translate }}</mat-label>
        <input matInput formControlName="number" disabled />
      </mat-form-field>

      <mat-form-field appearance="legacy">
        <mat-label>{{ 'MAINTENANCES.TYPES' | translate }}</mat-label>
        <input matInput formControlName="type" disabled />
      </mat-form-field>

      <mat-form-field appearance="legacy">
        <mat-label>{{ 'MAINTENANCES.OPENED_DATE' | translate }}</mat-label>
        <input matInput [matDatepicker]="openedPicker" formControlName="openedDate" disabled />
        <mat-datepicker-toggle matSuffix [for]="openedPicker"></mat-datepicker-toggle>
        <mat-datepicker #openedPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="legacy">
        <mat-label>{{ 'MAINTENANCES.OPENED_TIME' | translate }}</mat-label>
        <input matInput formControlName="openedTime" placeholder="__:__" mask="Hh:m0" disabled />
      </mat-form-field>

      <segments appearance="legacy" formControlName="segment" disabled> </segments>
    </div>

    <schedule-suggestions [form]="reopenMaintenancesForm"></schedule-suggestions>

    <div class="dialog-reopen-maintenance__content__card">
      <label class="dialog-reopen-maintenance__content__card__title">
        {{ 'MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.REOPEN' | translate }}
      </label>

      <mat-form-field appearance="legacy">
        <textarea
          matInput
          matTextareaAutosize
          placeholder="{{ 'MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.REOPENING_REASON_LABEL' | translate }}"
          matAutosizeMinRows="2"
          matAutosizeMaxRows="3"
          [formControl]="reopenMaintenancesForm.get('reopenReason')"
          required
        >
        </textarea>
        <mat-error *ngIf="reopenMaintenancesForm.get('reopenReason').hasError('required')">
          {{ 'MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <div class="dialog-reopen-maintenance__footer">
    <button
      [disabled]="
        reopenMaintenancesForm.get('reopenReason').invalid ||
        isReopenMaintenance ||
        isViewMode ||
        reopenMaintenancesForm.invalid
      "
      class="field-background"
      mat-raised-button
      (click)="reopenMaintenance()"
    >
      {{ 'MAINTENANCES.SAVE' | translate }}
    </button>
  </div>
</div>
